"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Med Manager Resource Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporateApiAxiosParamCreator = exports.AdministeredDrugOutcomeApi = exports.AdministeredDrugOutcomeApiFactory = exports.AdministeredDrugOutcomeApiFp = exports.AdministeredDrugOutcomeApiAxiosParamCreator = exports.AdministeredDrugCommentApi = exports.AdministeredDrugCommentApiFactory = exports.AdministeredDrugCommentApiFp = exports.AdministeredDrugCommentApiAxiosParamCreator = exports.AdministeredDrugApi = exports.AdministeredDrugApiFactory = exports.AdministeredDrugApiFp = exports.AdministeredDrugApiAxiosParamCreator = exports.AdministeredDoseApi = exports.AdministeredDoseApiFactory = exports.AdministeredDoseApiFp = exports.AdministeredDoseApiAxiosParamCreator = exports.AdministeredAdHocDrugOutcomeApi = exports.AdministeredAdHocDrugOutcomeApiFactory = exports.AdministeredAdHocDrugOutcomeApiFp = exports.AdministeredAdHocDrugOutcomeApiAxiosParamCreator = exports.AdministeredAdHocDrugCommentApi = exports.AdministeredAdHocDrugCommentApiFactory = exports.AdministeredAdHocDrugCommentApiFp = exports.AdministeredAdHocDrugCommentApiAxiosParamCreator = exports.AdministeredAdHocDrugApi = exports.AdministeredAdHocDrugApiFactory = exports.AdministeredAdHocDrugApiFp = exports.AdministeredAdHocDrugApiAxiosParamCreator = exports.SyringeDriverActivityKind = exports.SecondCheckType = exports.ScriptType = exports.ReasonCode = exports.PackType = exports.MedicationType = exports.MedicationStatus = exports.LoginType = exports.JsonValueKind = exports.InvitationStatus = exports.HandlingIndication = exports.HSUserSubRole = exports.GlobalRoleType = exports.Gender = exports.DoseRoundStatus = exports.CreateUserStatus = exports.CreateUserMessageType = exports.ChangeType = exports.CardColour = exports.AdHocType = exports.AdHocReasonCode = void 0;
exports.NimConsumerApiFactory = exports.NimConsumerApiFp = exports.NimConsumerApiAxiosParamCreator = exports.NimAvailableDrugApi = exports.NimAvailableDrugApiFactory = exports.NimAvailableDrugApiFp = exports.NimAvailableDrugApiAxiosParamCreator = exports.MedicationChartApi = exports.MedicationChartApiFactory = exports.MedicationChartApiFp = exports.MedicationChartApiAxiosParamCreator = exports.ImageApi = exports.ImageApiFactory = exports.ImageApiFp = exports.ImageApiAxiosParamCreator = exports.GlobalSettingsApi = exports.GlobalSettingsApiFactory = exports.GlobalSettingsApiFp = exports.GlobalSettingsApiAxiosParamCreator = exports.FacilityMovementsApi = exports.FacilityMovementsApiFactory = exports.FacilityMovementsApiFp = exports.FacilityMovementsApiAxiosParamCreator = exports.FacilityGroupsApi = exports.FacilityGroupsApiFactory = exports.FacilityGroupsApiFp = exports.FacilityGroupsApiAxiosParamCreator = exports.FacilitiesApi = exports.FacilitiesApiFactory = exports.FacilitiesApiFp = exports.FacilitiesApiAxiosParamCreator = exports.EmailApi = exports.EmailApiFactory = exports.EmailApiFp = exports.EmailApiAxiosParamCreator = exports.DrugsApi = exports.DrugsApiFactory = exports.DrugsApiFp = exports.DrugsApiAxiosParamCreator = exports.DrugFormsApi = exports.DrugFormsApiFactory = exports.DrugFormsApiFp = exports.DrugFormsApiAxiosParamCreator = exports.DrugCategoriesApi = exports.DrugCategoriesApiFactory = exports.DrugCategoriesApiFp = exports.DrugCategoriesApiAxiosParamCreator = exports.CorporateApi = exports.CorporateApiFactory = exports.CorporateApiFp = void 0;
exports.RoleApiAxiosParamCreator = exports.ReportingApi = exports.ReportingApiFactory = exports.ReportingApiFp = exports.ReportingApiAxiosParamCreator = exports.PermissionsApi = exports.PermissionsApiFactory = exports.PermissionsApiFp = exports.PermissionsApiAxiosParamCreator = exports.PatientsApi = exports.PatientsApiFactory = exports.PatientsApiFp = exports.PatientsApiAxiosParamCreator = exports.PatientProgressNoteApi = exports.PatientProgressNoteApiFactory = exports.PatientProgressNoteApiFp = exports.PatientProgressNoteApiAxiosParamCreator = exports.PatientMovementsApi = exports.PatientMovementsApiFactory = exports.PatientMovementsApiFp = exports.PatientMovementsApiAxiosParamCreator = exports.PatientMedicationApi = exports.PatientMedicationApiFactory = exports.PatientMedicationApiFp = exports.PatientMedicationApiAxiosParamCreator = exports.PatchObservationsApi = exports.PatchObservationsApiFactory = exports.PatchObservationsApiFp = exports.PatchObservationsApiAxiosParamCreator = exports.PatchManagementApi = exports.PatchManagementApiFactory = exports.PatchManagementApiFp = exports.PatchManagementApiAxiosParamCreator = exports.PackedPatientPrnMedicationApi = exports.PackedPatientPrnMedicationApiFactory = exports.PackedPatientPrnMedicationApiFp = exports.PackedPatientPrnMedicationApiAxiosParamCreator = exports.PackedPatientDayApi = exports.PackedPatientDayApiFactory = exports.PackedPatientDayApiFp = exports.PackedPatientDayApiAxiosParamCreator = exports.OrdersCommentApi = exports.OrdersCommentApiFactory = exports.OrdersCommentApiFp = exports.OrdersCommentApiAxiosParamCreator = exports.OrdersApi = exports.OrdersApiFactory = exports.OrdersApiFp = exports.OrdersApiAxiosParamCreator = exports.NimConsumerApi = void 0;
exports.WarningDetailsApi = exports.WarningDetailsApiFactory = exports.WarningDetailsApiFp = exports.WarningDetailsApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.TestResultApi = exports.TestResultApiFactory = exports.TestResultApiFp = exports.TestResultApiAxiosParamCreator = exports.SyringeDriverActivityCommentsApi = exports.SyringeDriverActivityCommentsApiFactory = exports.SyringeDriverActivityCommentsApiFp = exports.SyringeDriverActivityCommentsApiAxiosParamCreator = exports.SyringeDriverActivitiesApi = exports.SyringeDriverActivitiesApiFactory = exports.SyringeDriverActivitiesApiFp = exports.SyringeDriverActivitiesApiAxiosParamCreator = exports.SessionApi = exports.SessionApiFactory = exports.SessionApiFp = exports.SessionApiAxiosParamCreator = exports.SecondCheckSettingApi = exports.SecondCheckSettingApiFactory = exports.SecondCheckSettingApiFp = exports.SecondCheckSettingApiAxiosParamCreator = exports.RoundsApi = exports.RoundsApiFactory = exports.RoundsApiFp = exports.RoundsApiAxiosParamCreator = exports.RoundSegmentApi = exports.RoundSegmentApiFactory = exports.RoundSegmentApiFp = exports.RoundSegmentApiAxiosParamCreator = exports.RoleApi = exports.RoleApiFactory = exports.RoleApiFp = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AdHocReasonCode = {
    Dosed: 'Dosed',
    Absent: 'Absent',
    Omitted: 'Omitted',
    Refused: 'Refused',
    NoStock: 'NoStock',
    Withheld: 'Withheld',
    Vomiting: 'Vomiting',
    Other: 'Other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AdHocType = {
    NurseInitiated: 'NurseInitiated'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CardColour = {
    White: 'White',
    Orange: 'Orange',
    Gold: 'Gold'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ChangeType = {
    None: 'None',
    Added: 'Added',
    Modified: 'Modified',
    Deleted: 'Deleted',
    Child: 'Child'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CreateUserMessageType = {
    Info: 'Info',
    Warning: 'Warning',
    Error: 'Error'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CreateUserStatus = {
    Created: 'Created',
    AccessExists: 'AccessExists',
    Error: 'Error'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DoseRoundStatus = {
    Pending: 'Pending',
    InProgress: 'InProgress',
    Paused: 'Paused',
    Completing: 'Completing',
    Completed: 'Completed',
    Deleted: 'Deleted'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Gender = {
    Male: 'Male',
    Female: 'Female',
    Unspecified: 'Unspecified'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GlobalRoleType = {
    None: 'None',
    SystemAdmin: 'SystemAdmin',
    SystemSupport: 'SystemSupport'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HSUserSubRole = {
    Undefined: 'Undefined',
    RegisteredNurse: 'RegisteredNurse',
    EnrolledNurse: 'EnrolledNurse',
    PersonalCarer: 'PersonalCarer',
    Administrator: 'Administrator',
    Doctor: 'Doctor',
    SyncAccount: 'SyncAccount'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HandlingIndication = {
    None: 'None',
    HandleWithCare: 'HandleWithCare',
    Cytotoxic: 'Cytotoxic'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.InvitationStatus = {
    Pending: 'Pending',
    Accepted: 'Accepted'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.JsonValueKind = {
    Undefined: 'Undefined',
    Object: 'Object',
    Array: 'Array',
    String: 'String',
    Number: 'Number',
    True: 'True',
    False: 'False',
    Null: 'Null'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LoginType = {
    Local: 'Local',
    Sso: 'SSO'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MedicationStatus = {
    Unconfirmed: 'Unconfirmed',
    Confirmed: 'Confirmed',
    Deleted: 'Deleted',
    PendingDelete: 'PendingDelete'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MedicationType = {
    Regular: 'Regular',
    Prn: 'Prn',
    ShortCourse: 'ShortCourse'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PackType = {
    None: 'None',
    Packette: 'Packette',
    Blister: 'Blister',
    OriginalContainer: 'OriginalContainer'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReasonCode = {
    Dosed: 'Dosed',
    DosedLate: 'DosedLate',
    Absent: 'Absent',
    Omitted: 'Omitted',
    Refused: 'Refused',
    Fasting: 'Fasting',
    SelfAdministered: 'SelfAdministered',
    NoStock: 'NoStock',
    OnDoctorOrder: 'OnDoctorOrder',
    Leave: 'Leave',
    Withheld: 'Withheld',
    Ceased: 'Ceased',
    CourseComplete: 'CourseComplete',
    Hospital: 'Hospital',
    Vomiting: 'Vomiting',
    RequiresRn: 'RequiresRN',
    ExcludePatient: 'ExcludePatient',
    Timeout: 'Timeout',
    ForceClose: 'ForceClose',
    Other: 'Other',
    DoseSupplied: 'DoseSupplied'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ScriptType = {
    None: 'None',
    Pbs: 'Pbs',
    Rpbs: 'Rpbs',
    Private: 'Private'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SecondCheckType = {
    Route: 'Route',
    Category: 'Category',
    Drug: 'Drug'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SyringeDriverActivityKind = {
    Start: 'Start',
    Stop: 'Stop',
    Pause: 'Pause',
    Restart: 'Restart',
    Cease: 'Cease',
    Observation: 'Observation'
};
/**
 * AdministeredAdHocDrugApi - axios parameter creator
 * @export
 */
const AdministeredAdHocDrugApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugReq} [createAdministeredAdHocDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCreateAdministeredAdHocDrug: (createAdministeredAdHocDrugReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredAdHocDrugReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredAdHocDrug} [hSAdministeredAdHocDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugUpdateAdministeredDrug: (hSAdministeredAdHocDrug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredAdHocDrug, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredAdHocDrugApiAxiosParamCreator = AdministeredAdHocDrugApiAxiosParamCreator;
/**
 * AdministeredAdHocDrugApi - functional programming interface
 * @export
 */
const AdministeredAdHocDrugApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredAdHocDrugApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugReq} [createAdministeredAdHocDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredAdHocDrug} [hSAdministeredAdHocDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredAdHocDrugApiFp = AdministeredAdHocDrugApiFp;
/**
 * AdministeredAdHocDrugApi - factory interface
 * @export
 */
const AdministeredAdHocDrugApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredAdHocDrugApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugReq} [createAdministeredAdHocDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options) {
            return localVarFp.administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredAdHocDrug} [hSAdministeredAdHocDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options) {
            return localVarFp.administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredAdHocDrugApiFactory = AdministeredAdHocDrugApiFactory;
/**
 * AdministeredAdHocDrugApi - object-oriented interface
 * @export
 * @class AdministeredAdHocDrugApi
 * @extends {BaseAPI}
 */
class AdministeredAdHocDrugApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredAdHocDrugReq} [createAdministeredAdHocDrugReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugApi
     */
    administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options) {
        return exports.AdministeredAdHocDrugApiFp(this.configuration).administeredAdHocDrugCreateAdministeredAdHocDrug(createAdministeredAdHocDrugReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredAdHocDrug} [hSAdministeredAdHocDrug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugApi
     */
    administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options) {
        return exports.AdministeredAdHocDrugApiFp(this.configuration).administeredAdHocDrugUpdateAdministeredDrug(hSAdministeredAdHocDrug, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredAdHocDrugApi = AdministeredAdHocDrugApi;
/**
 * AdministeredAdHocDrugCommentApi - axios parameter creator
 * @export
 */
const AdministeredAdHocDrugCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugCommentReq} [createAdministeredAdHocDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment: (createAdministeredAdHocDrugCommentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug-comment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredAdHocDrugCommentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment: (hSAdministeredAdHocDrugComment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug-comment/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredAdHocDrugComment, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredAdHocDrugCommentApiAxiosParamCreator = AdministeredAdHocDrugCommentApiAxiosParamCreator;
/**
 * AdministeredAdHocDrugCommentApi - functional programming interface
 * @export
 */
const AdministeredAdHocDrugCommentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredAdHocDrugCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugCommentReq} [createAdministeredAdHocDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredAdHocDrugCommentApiFp = AdministeredAdHocDrugCommentApiFp;
/**
 * AdministeredAdHocDrugCommentApi - factory interface
 * @export
 */
const AdministeredAdHocDrugCommentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredAdHocDrugCommentApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugCommentReq} [createAdministeredAdHocDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options) {
            return localVarFp.administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
            return localVarFp.administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredAdHocDrugCommentApiFactory = AdministeredAdHocDrugCommentApiFactory;
/**
 * AdministeredAdHocDrugCommentApi - object-oriented interface
 * @export
 * @class AdministeredAdHocDrugCommentApi
 * @extends {BaseAPI}
 */
class AdministeredAdHocDrugCommentApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredAdHocDrugCommentReq} [createAdministeredAdHocDrugCommentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugCommentApi
     */
    administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options) {
        return exports.AdministeredAdHocDrugCommentApiFp(this.configuration).administeredAdHocDrugCommentCreateAdministeredAdHocDrugComment(createAdministeredAdHocDrugCommentReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugCommentApi
     */
    administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
        return exports.AdministeredAdHocDrugCommentApiFp(this.configuration).administeredAdHocDrugCommentUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredAdHocDrugCommentApi = AdministeredAdHocDrugCommentApi;
/**
 * AdministeredAdHocDrugOutcomeApi - axios parameter creator
 * @export
 */
const AdministeredAdHocDrugOutcomeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugOutcomeReq} [createAdministeredAdHocDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome: (createAdministeredAdHocDrugOutcomeReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug-outcome/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredAdHocDrugOutcomeReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment: (hSAdministeredAdHocDrugComment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-adhoc-drug-outcome/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredAdHocDrugComment, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredAdHocDrugOutcomeApiAxiosParamCreator = AdministeredAdHocDrugOutcomeApiAxiosParamCreator;
/**
 * AdministeredAdHocDrugOutcomeApi - functional programming interface
 * @export
 */
const AdministeredAdHocDrugOutcomeApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredAdHocDrugOutcomeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugOutcomeReq} [createAdministeredAdHocDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredAdHocDrugOutcomeApiFp = AdministeredAdHocDrugOutcomeApiFp;
/**
 * AdministeredAdHocDrugOutcomeApi - factory interface
 * @export
 */
const AdministeredAdHocDrugOutcomeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredAdHocDrugOutcomeApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredAdHocDrugOutcomeReq} [createAdministeredAdHocDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options) {
            return localVarFp.administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
            return localVarFp.administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredAdHocDrugOutcomeApiFactory = AdministeredAdHocDrugOutcomeApiFactory;
/**
 * AdministeredAdHocDrugOutcomeApi - object-oriented interface
 * @export
 * @class AdministeredAdHocDrugOutcomeApi
 * @extends {BaseAPI}
 */
class AdministeredAdHocDrugOutcomeApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredAdHocDrugOutcomeReq} [createAdministeredAdHocDrugOutcomeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugOutcomeApi
     */
    administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options) {
        return exports.AdministeredAdHocDrugOutcomeApiFp(this.configuration).administeredAdHocDrugOutcomeCreateAdministeredAdHocDrugOutcome(createAdministeredAdHocDrugOutcomeReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredAdHocDrugComment} [hSAdministeredAdHocDrugComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredAdHocDrugOutcomeApi
     */
    administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options) {
        return exports.AdministeredAdHocDrugOutcomeApiFp(this.configuration).administeredAdHocDrugOutcomeUpdateAdministeredAdHocDrugComment(hSAdministeredAdHocDrugComment, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredAdHocDrugOutcomeApi = AdministeredAdHocDrugOutcomeApi;
/**
 * AdministeredDoseApi - axios parameter creator
 * @export
 */
const AdministeredDoseApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredDoseReq} [createAdministeredDoseReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseCreateDose: (createAdministeredDoseReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-dose/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredDoseReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredDose} [hSAdministeredDose]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseUpdateDose: (hSAdministeredDose, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-dose/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredDose, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredDoseApiAxiosParamCreator = AdministeredDoseApiAxiosParamCreator;
/**
 * AdministeredDoseApi - functional programming interface
 * @export
 */
const AdministeredDoseApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredDoseApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDoseReq} [createAdministeredDoseReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseCreateDose(createAdministeredDoseReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDoseCreateDose(createAdministeredDoseReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredDose} [hSAdministeredDose]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseUpdateDose(hSAdministeredDose, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDoseUpdateDose(hSAdministeredDose, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredDoseApiFp = AdministeredDoseApiFp;
/**
 * AdministeredDoseApi - factory interface
 * @export
 */
const AdministeredDoseApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredDoseApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDoseReq} [createAdministeredDoseReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseCreateDose(createAdministeredDoseReq, options) {
            return localVarFp.administeredDoseCreateDose(createAdministeredDoseReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredDose} [hSAdministeredDose]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDoseUpdateDose(hSAdministeredDose, options) {
            return localVarFp.administeredDoseUpdateDose(hSAdministeredDose, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredDoseApiFactory = AdministeredDoseApiFactory;
/**
 * AdministeredDoseApi - object-oriented interface
 * @export
 * @class AdministeredDoseApi
 * @extends {BaseAPI}
 */
class AdministeredDoseApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredDoseReq} [createAdministeredDoseReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDoseApi
     */
    administeredDoseCreateDose(createAdministeredDoseReq, options) {
        return exports.AdministeredDoseApiFp(this.configuration).administeredDoseCreateDose(createAdministeredDoseReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredDose} [hSAdministeredDose]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDoseApi
     */
    administeredDoseUpdateDose(hSAdministeredDose, options) {
        return exports.AdministeredDoseApiFp(this.configuration).administeredDoseUpdateDose(hSAdministeredDose, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredDoseApi = AdministeredDoseApi;
/**
 * AdministeredDrugApi - axios parameter creator
 * @export
 */
const AdministeredDrugApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredDrugReq} [createAdministeredDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCreateAdministeredDrug: (createAdministeredDrugReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredDrugReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredDrug} [hSAdministeredDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugUpdateAdministeredDrug: (hSAdministeredDrug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredDrug, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredDrugApiAxiosParamCreator = AdministeredDrugApiAxiosParamCreator;
/**
 * AdministeredDrugApi - functional programming interface
 * @export
 */
const AdministeredDrugApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredDrugApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugReq} [createAdministeredDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredDrug} [hSAdministeredDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredDrugApiFp = AdministeredDrugApiFp;
/**
 * AdministeredDrugApi - factory interface
 * @export
 */
const AdministeredDrugApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredDrugApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugReq} [createAdministeredDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options) {
            return localVarFp.administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredDrug} [hSAdministeredDrug]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options) {
            return localVarFp.administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredDrugApiFactory = AdministeredDrugApiFactory;
/**
 * AdministeredDrugApi - object-oriented interface
 * @export
 * @class AdministeredDrugApi
 * @extends {BaseAPI}
 */
class AdministeredDrugApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredDrugReq} [createAdministeredDrugReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugApi
     */
    administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options) {
        return exports.AdministeredDrugApiFp(this.configuration).administeredDrugCreateAdministeredDrug(createAdministeredDrugReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredDrug} [hSAdministeredDrug]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugApi
     */
    administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options) {
        return exports.AdministeredDrugApiFp(this.configuration).administeredDrugUpdateAdministeredDrug(hSAdministeredDrug, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredDrugApi = AdministeredDrugApi;
/**
 * AdministeredDrugCommentApi - axios parameter creator
 * @export
 */
const AdministeredDrugCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredDrugCommentReq} [createAdministeredDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentCreateAdministeredDrugComment: (createAdministeredDrugCommentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug-comment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredDrugCommentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredDrugComment} [hSAdministeredDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentUpdateAdministeredDrugComment: (hSAdministeredDrugComment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug-comment/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredDrugComment, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredDrugCommentApiAxiosParamCreator = AdministeredDrugCommentApiAxiosParamCreator;
/**
 * AdministeredDrugCommentApi - functional programming interface
 * @export
 */
const AdministeredDrugCommentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredDrugCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugCommentReq} [createAdministeredDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredDrugComment} [hSAdministeredDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredDrugCommentApiFp = AdministeredDrugCommentApiFp;
/**
 * AdministeredDrugCommentApi - factory interface
 * @export
 */
const AdministeredDrugCommentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredDrugCommentApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugCommentReq} [createAdministeredDrugCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options) {
            return localVarFp.administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredDrugComment} [hSAdministeredDrugComment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options) {
            return localVarFp.administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredDrugCommentApiFactory = AdministeredDrugCommentApiFactory;
/**
 * AdministeredDrugCommentApi - object-oriented interface
 * @export
 * @class AdministeredDrugCommentApi
 * @extends {BaseAPI}
 */
class AdministeredDrugCommentApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredDrugCommentReq} [createAdministeredDrugCommentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugCommentApi
     */
    administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options) {
        return exports.AdministeredDrugCommentApiFp(this.configuration).administeredDrugCommentCreateAdministeredDrugComment(createAdministeredDrugCommentReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredDrugComment} [hSAdministeredDrugComment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugCommentApi
     */
    administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options) {
        return exports.AdministeredDrugCommentApiFp(this.configuration).administeredDrugCommentUpdateAdministeredDrugComment(hSAdministeredDrugComment, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredDrugCommentApi = AdministeredDrugCommentApi;
/**
 * AdministeredDrugOutcomeApi - axios parameter creator
 * @export
 */
const AdministeredDrugOutcomeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateAdministeredDrugOutcomeReq} [createAdministeredDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeCreateAdministeredDrugOutcome: (createAdministeredDrugOutcomeReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug-outcome/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAdministeredDrugOutcomeReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HSAdministeredDrugOutcome} [hSAdministeredDrugOutcome]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeUpdateAdministeredDrugOutcome: (hSAdministeredDrugOutcome, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/administered-drug-outcome/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(hSAdministeredDrugOutcome, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdministeredDrugOutcomeApiAxiosParamCreator = AdministeredDrugOutcomeApiAxiosParamCreator;
/**
 * AdministeredDrugOutcomeApi - functional programming interface
 * @export
 */
const AdministeredDrugOutcomeApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdministeredDrugOutcomeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugOutcomeReq} [createAdministeredDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HSAdministeredDrugOutcome} [hSAdministeredDrugOutcome]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdministeredDrugOutcomeApiFp = AdministeredDrugOutcomeApiFp;
/**
 * AdministeredDrugOutcomeApi - factory interface
 * @export
 */
const AdministeredDrugOutcomeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdministeredDrugOutcomeApiFp(configuration);
    return {
        /**
         *
         * @param {CreateAdministeredDrugOutcomeReq} [createAdministeredDrugOutcomeReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options) {
            return localVarFp.administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HSAdministeredDrugOutcome} [hSAdministeredDrugOutcome]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options) {
            return localVarFp.administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdministeredDrugOutcomeApiFactory = AdministeredDrugOutcomeApiFactory;
/**
 * AdministeredDrugOutcomeApi - object-oriented interface
 * @export
 * @class AdministeredDrugOutcomeApi
 * @extends {BaseAPI}
 */
class AdministeredDrugOutcomeApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateAdministeredDrugOutcomeReq} [createAdministeredDrugOutcomeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugOutcomeApi
     */
    administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options) {
        return exports.AdministeredDrugOutcomeApiFp(this.configuration).administeredDrugOutcomeCreateAdministeredDrugOutcome(createAdministeredDrugOutcomeReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {HSAdministeredDrugOutcome} [hSAdministeredDrugOutcome]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministeredDrugOutcomeApi
     */
    administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options) {
        return exports.AdministeredDrugOutcomeApiFp(this.configuration).administeredDrugOutcomeUpdateAdministeredDrugOutcome(hSAdministeredDrugOutcome, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdministeredDrugOutcomeApi = AdministeredDrugOutcomeApi;
/**
 * CorporateApi - axios parameter creator
 * @export
 */
const CorporateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateListCorporates: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/corporate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.CorporateApiAxiosParamCreator = CorporateApiAxiosParamCreator;
/**
 * CorporateApi - functional programming interface
 * @export
 */
const CorporateApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CorporateApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateListCorporates(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.corporateListCorporates(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.CorporateApiFp = CorporateApiFp;
/**
 * CorporateApi - factory interface
 * @export
 */
const CorporateApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CorporateApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        corporateListCorporates(options) {
            return localVarFp.corporateListCorporates(options).then((request) => request(axios, basePath));
        },
    };
};
exports.CorporateApiFactory = CorporateApiFactory;
/**
 * CorporateApi - object-oriented interface
 * @export
 * @class CorporateApi
 * @extends {BaseAPI}
 */
class CorporateApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    corporateListCorporates(options) {
        return exports.CorporateApiFp(this.configuration).corporateListCorporates(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CorporateApi = CorporateApi;
/**
 * DrugCategoriesApi - axios parameter creator
 * @export
 */
const DrugCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [etag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugCategoriesListDrugCategories: (etag, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/drug-categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (etag !== undefined) {
                localVarQueryParameter['etag'] = etag;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DrugCategoriesApiAxiosParamCreator = DrugCategoriesApiAxiosParamCreator;
/**
 * DrugCategoriesApi - functional programming interface
 * @export
 */
const DrugCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DrugCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [etag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugCategoriesListDrugCategories(etag, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.drugCategoriesListDrugCategories(etag, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DrugCategoriesApiFp = DrugCategoriesApiFp;
/**
 * DrugCategoriesApi - factory interface
 * @export
 */
const DrugCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DrugCategoriesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [etag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugCategoriesListDrugCategories(etag, options) {
            return localVarFp.drugCategoriesListDrugCategories(etag, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DrugCategoriesApiFactory = DrugCategoriesApiFactory;
/**
 * DrugCategoriesApi - object-oriented interface
 * @export
 * @class DrugCategoriesApi
 * @extends {BaseAPI}
 */
class DrugCategoriesApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [etag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugCategoriesApi
     */
    drugCategoriesListDrugCategories(etag, options) {
        return exports.DrugCategoriesApiFp(this.configuration).drugCategoriesListDrugCategories(etag, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DrugCategoriesApi = DrugCategoriesApi;
/**
 * DrugFormsApi - axios parameter creator
 * @export
 */
const DrugFormsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] the default page size is 1000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugFormsListDrugForms: (changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/drug-forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DrugFormsApiAxiosParamCreator = DrugFormsApiAxiosParamCreator;
/**
 * DrugFormsApi - functional programming interface
 * @export
 */
const DrugFormsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DrugFormsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] the default page size is 1000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugFormsListDrugForms(changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.drugFormsListDrugForms(changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DrugFormsApiFp = DrugFormsApiFp;
/**
 * DrugFormsApi - factory interface
 * @export
 */
const DrugFormsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DrugFormsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] the default page size is 1000
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugFormsListDrugForms(changeNumber, pageSize, options) {
            return localVarFp.drugFormsListDrugForms(changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DrugFormsApiFactory = DrugFormsApiFactory;
/**
 * DrugFormsApi - object-oriented interface
 * @export
 * @class DrugFormsApi
 * @extends {BaseAPI}
 */
class DrugFormsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [changeNumber]
     * @param {number} [pageSize] the default page size is 1000
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugFormsApi
     */
    drugFormsListDrugForms(changeNumber, pageSize, options) {
        return exports.DrugFormsApiFp(this.configuration).drugFormsListDrugForms(changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DrugFormsApi = DrugFormsApi;
/**
 * DrugsApi - axios parameter creator
 * @export
 */
const DrugsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugsListDrugs: (changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/drugs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DrugsApiAxiosParamCreator = DrugsApiAxiosParamCreator;
/**
 * DrugsApi - functional programming interface
 * @export
 */
const DrugsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DrugsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugsListDrugs(changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.drugsListDrugs(changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DrugsApiFp = DrugsApiFp;
/**
 * DrugsApi - factory interface
 * @export
 */
const DrugsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DrugsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drugsListDrugs(changeNumber, pageSize, options) {
            return localVarFp.drugsListDrugs(changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DrugsApiFactory = DrugsApiFactory;
/**
 * DrugsApi - object-oriented interface
 * @export
 * @class DrugsApi
 * @extends {BaseAPI}
 */
class DrugsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [changeNumber]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrugsApi
     */
    drugsListDrugs(changeNumber, pageSize, options) {
        return exports.DrugsApiFp(this.configuration).drugsListDrugs(changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DrugsApi = DrugsApi;
/**
 * EmailApi - axios parameter creator
 * @export
 */
const EmailApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {EmailReq} [emailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend: (emailReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(emailReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmailApiAxiosParamCreator = EmailApiAxiosParamCreator;
/**
 * EmailApi - functional programming interface
 * @export
 */
const EmailApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EmailApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {EmailReq} [emailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend(emailReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.emailSend(emailReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EmailApiFp = EmailApiFp;
/**
 * EmailApi - factory interface
 * @export
 */
const EmailApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EmailApiFp(configuration);
    return {
        /**
         *
         * @param {EmailReq} [emailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailSend(emailReq, options) {
            return localVarFp.emailSend(emailReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmailApiFactory = EmailApiFactory;
/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
class EmailApi extends base_1.BaseAPI {
    /**
     *
     * @param {EmailReq} [emailReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    emailSend(emailReq, options) {
        return exports.EmailApiFp(this.configuration).emailSend(emailReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmailApi = EmailApi;
/**
 * FacilitiesApi - axios parameter creator
 * @export
 */
const FacilitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesListFacilities: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FacilitiesApiAxiosParamCreator = FacilitiesApiAxiosParamCreator;
/**
 * FacilitiesApi - functional programming interface
 * @export
 */
const FacilitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.FacilitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesListFacilities(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilitiesListFacilities(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FacilitiesApiFp = FacilitiesApiFp;
/**
 * FacilitiesApi - factory interface
 * @export
 */
const FacilitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.FacilitiesApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesListFacilities(options) {
            return localVarFp.facilitiesListFacilities(options).then((request) => request(axios, basePath));
        },
    };
};
exports.FacilitiesApiFactory = FacilitiesApiFactory;
/**
 * FacilitiesApi - object-oriented interface
 * @export
 * @class FacilitiesApi
 * @extends {BaseAPI}
 */
class FacilitiesApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilitiesApi
     */
    facilitiesListFacilities(options) {
        return exports.FacilitiesApiFp(this.configuration).facilitiesListFacilities(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FacilitiesApi = FacilitiesApi;
/**
 * FacilityGroupsApi - axios parameter creator
 * @export
 */
const FacilityGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsGetFacilityGroupConfiguration: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('facilityGroupsGetFacilityGroupConfiguration', 'facilityGroupId', facilityGroupId);
            const localVarPath = `/facility-groups/configuration/{facilityGroupId}`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroups: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facility-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [changeNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroupsAvailableForOnboarding: (changeNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facility-groups/onboard/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {FacilityGroupOnboardingReq} [facilityGroupOnboardingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsOnboardFacility: (facilityGroupOnboardingReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facility-groups/onboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(facilityGroupOnboardingReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {FacilityGroupConfigurationDto} [facilityGroupConfigurationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsUpdateFacilityGroupConfiguration: (facilityGroupConfigurationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facility-groups/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(facilityGroupConfigurationDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FacilityGroupsApiAxiosParamCreator = FacilityGroupsApiAxiosParamCreator;
/**
 * FacilityGroupsApi - functional programming interface
 * @export
 */
const FacilityGroupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.FacilityGroupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityGroupsListFacilityGroups(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [changeNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {FacilityGroupOnboardingReq} [facilityGroupOnboardingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {FacilityGroupConfigurationDto} [facilityGroupConfigurationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FacilityGroupsApiFp = FacilityGroupsApiFp;
/**
 * FacilityGroupsApi - factory interface
 * @export
 */
const FacilityGroupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.FacilityGroupsApiFp(configuration);
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options) {
            return localVarFp.facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroups(options) {
            return localVarFp.facilityGroupsListFacilityGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [changeNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options) {
            return localVarFp.facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FacilityGroupOnboardingReq} [facilityGroupOnboardingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options) {
            return localVarFp.facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FacilityGroupConfigurationDto} [facilityGroupConfigurationDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options) {
            return localVarFp.facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FacilityGroupsApiFactory = FacilityGroupsApiFactory;
/**
 * FacilityGroupsApi - object-oriented interface
 * @export
 * @class FacilityGroupsApi
 * @extends {BaseAPI}
 */
class FacilityGroupsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} facilityGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityGroupsApi
     */
    facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options) {
        return exports.FacilityGroupsApiFp(this.configuration).facilityGroupsGetFacilityGroupConfiguration(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityGroupsApi
     */
    facilityGroupsListFacilityGroups(options) {
        return exports.FacilityGroupsApiFp(this.configuration).facilityGroupsListFacilityGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [changeNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityGroupsApi
     */
    facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options) {
        return exports.FacilityGroupsApiFp(this.configuration).facilityGroupsListFacilityGroupsAvailableForOnboarding(changeNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FacilityGroupOnboardingReq} [facilityGroupOnboardingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityGroupsApi
     */
    facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options) {
        return exports.FacilityGroupsApiFp(this.configuration).facilityGroupsOnboardFacility(facilityGroupOnboardingReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FacilityGroupConfigurationDto} [facilityGroupConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityGroupsApi
     */
    facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options) {
        return exports.FacilityGroupsApiFp(this.configuration).facilityGroupsUpdateFacilityGroupConfiguration(facilityGroupConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FacilityGroupsApi = FacilityGroupsApi;
/**
 * FacilityMovementsApi - axios parameter creator
 * @export
 */
const FacilityMovementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityMovementsListFacilityMovements: (facilityGroupId, changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/facility-movements/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FacilityMovementsApiAxiosParamCreator = FacilityMovementsApiAxiosParamCreator;
/**
 * FacilityMovementsApi - functional programming interface
 * @export
 */
const FacilityMovementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.FacilityMovementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FacilityMovementsApiFp = FacilityMovementsApiFp;
/**
 * FacilityMovementsApi - factory interface
 * @export
 */
const FacilityMovementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.FacilityMovementsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options) {
            return localVarFp.facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FacilityMovementsApiFactory = FacilityMovementsApiFactory;
/**
 * FacilityMovementsApi - object-oriented interface
 * @export
 * @class FacilityMovementsApi
 * @extends {BaseAPI}
 */
class FacilityMovementsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {number} [changeNumber]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityMovementsApi
     */
    facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options) {
        return exports.FacilityMovementsApiFp(this.configuration).facilityMovementsListFacilityMovements(facilityGroupId, changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FacilityMovementsApi = FacilityMovementsApi;
/**
 * GlobalSettingsApi - axios parameter creator
 * @export
 */
const GlobalSettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsShow: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/global-settings/show`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GlobalConfigurationReq} [globalConfigurationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsUpdate: (globalConfigurationReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/global-settings/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(globalConfigurationReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.GlobalSettingsApiAxiosParamCreator = GlobalSettingsApiAxiosParamCreator;
/**
 * GlobalSettingsApi - functional programming interface
 * @export
 */
const GlobalSettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.GlobalSettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsShow(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.globalSettingsShow(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GlobalConfigurationReq} [globalConfigurationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsUpdate(globalConfigurationReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.globalSettingsUpdate(globalConfigurationReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.GlobalSettingsApiFp = GlobalSettingsApiFp;
/**
 * GlobalSettingsApi - factory interface
 * @export
 */
const GlobalSettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.GlobalSettingsApiFp(configuration);
    return {
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsShow(options) {
            return localVarFp.globalSettingsShow(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GlobalConfigurationReq} [globalConfigurationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        globalSettingsUpdate(globalConfigurationReq, options) {
            return localVarFp.globalSettingsUpdate(globalConfigurationReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GlobalSettingsApiFactory = GlobalSettingsApiFactory;
/**
 * GlobalSettingsApi - object-oriented interface
 * @export
 * @class GlobalSettingsApi
 * @extends {BaseAPI}
 */
class GlobalSettingsApi extends base_1.BaseAPI {
    /**
     *
     * @summary returns warning details for the logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsApi
     */
    globalSettingsShow(options) {
        return exports.GlobalSettingsApiFp(this.configuration).globalSettingsShow(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GlobalConfigurationReq} [globalConfigurationReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSettingsApi
     */
    globalSettingsUpdate(globalConfigurationReq, options) {
        return exports.GlobalSettingsApiFp(this.configuration).globalSettingsUpdate(globalConfigurationReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GlobalSettingsApi = GlobalSettingsApi;
/**
 * ImageApi - axios parameter creator
 * @export
 */
const ImageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {string} [uri]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetImage: (facilityGroupId, uri, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (uri !== undefined) {
                localVarQueryParameter['uri'] = uri;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetPatientImage: (patientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('imageGetPatientImage', 'patientId', patientId);
            const localVarPath = `/images/silhouettes/{patientId}.jpg`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetTabletImage: (dcode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dcode' is not null or undefined
            common_1.assertParamExists('imageGetTabletImage', 'dcode', dcode);
            const localVarPath = `/images/hs/tabs/{dcode}.jpg`
                .replace(`{${"dcode"}}`, encodeURIComponent(String(dcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ImageApiAxiosParamCreator = ImageApiAxiosParamCreator;
/**
 * ImageApi - functional programming interface
 * @export
 */
const ImageApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ImageApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {string} [uri]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetImage(facilityGroupId, uri, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageGetImage(facilityGroupId, uri, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetPatientImage(patientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageGetPatientImage(patientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetTabletImage(dcode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imageGetTabletImage(dcode, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ImageApiFp = ImageApiFp;
/**
 * ImageApi - factory interface
 * @export
 */
const ImageApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ImageApiFp(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {string} [uri]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetImage(facilityGroupId, uri, options) {
            return localVarFp.imageGetImage(facilityGroupId, uri, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetPatientImage(patientId, options) {
            return localVarFp.imageGetPatientImage(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imageGetTabletImage(dcode, options) {
            return localVarFp.imageGetTabletImage(dcode, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ImageApiFactory = ImageApiFactory;
/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
class ImageApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {string} [uri]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    imageGetImage(facilityGroupId, uri, options) {
        return exports.ImageApiFp(this.configuration).imageGetImage(facilityGroupId, uri, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    imageGetPatientImage(patientId, options) {
        return exports.ImageApiFp(this.configuration).imageGetPatientImage(patientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dcode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    imageGetTabletImage(dcode, options) {
        return exports.ImageApiFp(this.configuration).imageGetTabletImage(dcode, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ImageApi = ImageApi;
/**
 * MedicationChartApi - axios parameter creator
 * @export
 */
const MedicationChartApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationChartGetResidentMedicationSummary: (patientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/medication-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MedicationChartApiAxiosParamCreator = MedicationChartApiAxiosParamCreator;
/**
 * MedicationChartApi - functional programming interface
 * @export
 */
const MedicationChartApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MedicationChartApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationChartGetResidentMedicationSummary(patientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.medicationChartGetResidentMedicationSummary(patientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.MedicationChartApiFp = MedicationChartApiFp;
/**
 * MedicationChartApi - factory interface
 * @export
 */
const MedicationChartApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MedicationChartApiFp(configuration);
    return {
        /**
         *
         * @param {number} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medicationChartGetResidentMedicationSummary(patientId, options) {
            return localVarFp.medicationChartGetResidentMedicationSummary(patientId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MedicationChartApiFactory = MedicationChartApiFactory;
/**
 * MedicationChartApi - object-oriented interface
 * @export
 * @class MedicationChartApi
 * @extends {BaseAPI}
 */
class MedicationChartApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [patientId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicationChartApi
     */
    medicationChartGetResidentMedicationSummary(patientId, options) {
        return exports.MedicationChartApiFp(this.configuration).medicationChartGetResidentMedicationSummary(patientId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MedicationChartApi = MedicationChartApi;
/**
 * NimAvailableDrugApi - axios parameter creator
 * @export
 */
const NimAvailableDrugApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateNimAvailableDrugReq} [createNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugCreate: (createNimAvailableDrugReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-available-drug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createNimAvailableDrugReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeleteNimAvailableDrugReq} [deleteNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugDelete: (deleteNimAvailableDrugReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-available-drug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deleteNimAvailableDrugReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugList: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('nimAvailableDrugList', 'facilityGroupId', facilityGroupId);
            const localVarPath = `/nim-available-drug/{facilityGroupId}`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateNimAvailableDrugReq} [updateNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugUpdate: (updateNimAvailableDrugReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-available-drug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateNimAvailableDrugReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NimAvailableDrugApiAxiosParamCreator = NimAvailableDrugApiAxiosParamCreator;
/**
 * NimAvailableDrugApi - functional programming interface
 * @export
 */
const NimAvailableDrugApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NimAvailableDrugApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateNimAvailableDrugReq} [createNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugCreate(createNimAvailableDrugReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimAvailableDrugCreate(createNimAvailableDrugReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {DeleteNimAvailableDrugReq} [deleteNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugDelete(deleteNimAvailableDrugReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimAvailableDrugDelete(deleteNimAvailableDrugReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugList(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimAvailableDrugList(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdateNimAvailableDrugReq} [updateNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugUpdate(updateNimAvailableDrugReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimAvailableDrugUpdate(updateNimAvailableDrugReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NimAvailableDrugApiFp = NimAvailableDrugApiFp;
/**
 * NimAvailableDrugApi - factory interface
 * @export
 */
const NimAvailableDrugApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NimAvailableDrugApiFp(configuration);
    return {
        /**
         *
         * @param {CreateNimAvailableDrugReq} [createNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugCreate(createNimAvailableDrugReq, options) {
            return localVarFp.nimAvailableDrugCreate(createNimAvailableDrugReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DeleteNimAvailableDrugReq} [deleteNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugDelete(deleteNimAvailableDrugReq, options) {
            return localVarFp.nimAvailableDrugDelete(deleteNimAvailableDrugReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugList(facilityGroupId, options) {
            return localVarFp.nimAvailableDrugList(facilityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateNimAvailableDrugReq} [updateNimAvailableDrugReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimAvailableDrugUpdate(updateNimAvailableDrugReq, options) {
            return localVarFp.nimAvailableDrugUpdate(updateNimAvailableDrugReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.NimAvailableDrugApiFactory = NimAvailableDrugApiFactory;
/**
 * NimAvailableDrugApi - object-oriented interface
 * @export
 * @class NimAvailableDrugApi
 * @extends {BaseAPI}
 */
class NimAvailableDrugApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateNimAvailableDrugReq} [createNimAvailableDrugReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimAvailableDrugApi
     */
    nimAvailableDrugCreate(createNimAvailableDrugReq, options) {
        return exports.NimAvailableDrugApiFp(this.configuration).nimAvailableDrugCreate(createNimAvailableDrugReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DeleteNimAvailableDrugReq} [deleteNimAvailableDrugReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimAvailableDrugApi
     */
    nimAvailableDrugDelete(deleteNimAvailableDrugReq, options) {
        return exports.NimAvailableDrugApiFp(this.configuration).nimAvailableDrugDelete(deleteNimAvailableDrugReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} facilityGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimAvailableDrugApi
     */
    nimAvailableDrugList(facilityGroupId, options) {
        return exports.NimAvailableDrugApiFp(this.configuration).nimAvailableDrugList(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdateNimAvailableDrugReq} [updateNimAvailableDrugReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimAvailableDrugApi
     */
    nimAvailableDrugUpdate(updateNimAvailableDrugReq, options) {
        return exports.NimAvailableDrugApiFp(this.configuration).nimAvailableDrugUpdate(updateNimAvailableDrugReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NimAvailableDrugApi = NimAvailableDrugApi;
/**
 * NimConsumerApi - axios parameter creator
 * @export
 */
const NimConsumerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateNimConsumerReq} [createNimConsumerReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerCreate: (createNimConsumerReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-consumer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createNimConsumerReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {NimConsumerDto} [nimConsumerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerDelete: (nimConsumerDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-consumer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(nimConsumerDto, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} nimAvailableDrugId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerList: (nimAvailableDrugId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'nimAvailableDrugId' is not null or undefined
            common_1.assertParamExists('nimConsumerList', 'nimAvailableDrugId', nimAvailableDrugId);
            const localVarPath = `/nim-consumer/{nimAvailableDrugId}`
                .replace(`{${"nimAvailableDrugId"}}`, encodeURIComponent(String(nimAvailableDrugId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateNimConsumerCommentReq} [updateNimConsumerCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerUpdateComment: (updateNimConsumerCommentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/nim-consumer/comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateNimConsumerCommentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NimConsumerApiAxiosParamCreator = NimConsumerApiAxiosParamCreator;
/**
 * NimConsumerApi - functional programming interface
 * @export
 */
const NimConsumerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NimConsumerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateNimConsumerReq} [createNimConsumerReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerCreate(createNimConsumerReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimConsumerCreate(createNimConsumerReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {NimConsumerDto} [nimConsumerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerDelete(nimConsumerDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimConsumerDelete(nimConsumerDto, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} nimAvailableDrugId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerList(nimAvailableDrugId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimConsumerList(nimAvailableDrugId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdateNimConsumerCommentReq} [updateNimConsumerCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerUpdateComment(updateNimConsumerCommentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nimConsumerUpdateComment(updateNimConsumerCommentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NimConsumerApiFp = NimConsumerApiFp;
/**
 * NimConsumerApi - factory interface
 * @export
 */
const NimConsumerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NimConsumerApiFp(configuration);
    return {
        /**
         *
         * @param {CreateNimConsumerReq} [createNimConsumerReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerCreate(createNimConsumerReq, options) {
            return localVarFp.nimConsumerCreate(createNimConsumerReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NimConsumerDto} [nimConsumerDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerDelete(nimConsumerDto, options) {
            return localVarFp.nimConsumerDelete(nimConsumerDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} nimAvailableDrugId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerList(nimAvailableDrugId, options) {
            return localVarFp.nimConsumerList(nimAvailableDrugId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateNimConsumerCommentReq} [updateNimConsumerCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nimConsumerUpdateComment(updateNimConsumerCommentReq, options) {
            return localVarFp.nimConsumerUpdateComment(updateNimConsumerCommentReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.NimConsumerApiFactory = NimConsumerApiFactory;
/**
 * NimConsumerApi - object-oriented interface
 * @export
 * @class NimConsumerApi
 * @extends {BaseAPI}
 */
class NimConsumerApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateNimConsumerReq} [createNimConsumerReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimConsumerApi
     */
    nimConsumerCreate(createNimConsumerReq, options) {
        return exports.NimConsumerApiFp(this.configuration).nimConsumerCreate(createNimConsumerReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NimConsumerDto} [nimConsumerDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimConsumerApi
     */
    nimConsumerDelete(nimConsumerDto, options) {
        return exports.NimConsumerApiFp(this.configuration).nimConsumerDelete(nimConsumerDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} nimAvailableDrugId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimConsumerApi
     */
    nimConsumerList(nimAvailableDrugId, options) {
        return exports.NimConsumerApiFp(this.configuration).nimConsumerList(nimAvailableDrugId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdateNimConsumerCommentReq} [updateNimConsumerCommentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NimConsumerApi
     */
    nimConsumerUpdateComment(updateNimConsumerCommentReq, options) {
        return exports.NimConsumerApiFp(this.configuration).nimConsumerUpdateComment(updateNimConsumerCommentReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NimConsumerApi = NimConsumerApi;
/**
 * OrdersApi - axios parameter creator
 * @export
 */
const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CancelOrderRequest} [cancelOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancelOrder: (cancelOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/orders/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateOrderRequest} [createOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCreateOrder: (createOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/orders/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersListOrders: (facilityGroupId, changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.OrdersApiAxiosParamCreator = OrdersApiAxiosParamCreator;
/**
 * OrdersApi - functional programming interface
 * @export
 */
const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CancelOrderRequest} [cancelOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancelOrder(cancelOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersCancelOrder(cancelOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateOrderRequest} [createOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCreateOrder(createOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersCreateOrder(createOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersListOrders(facilityGroupId, changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersListOrders(facilityGroupId, changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.OrdersApiFp = OrdersApiFp;
/**
 * OrdersApi - factory interface
 * @export
 */
const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrdersApiFp(configuration);
    return {
        /**
         *
         * @param {CancelOrderRequest} [cancelOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCancelOrder(cancelOrderRequest, options) {
            return localVarFp.ordersCancelOrder(cancelOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateOrderRequest} [createOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCreateOrder(createOrderRequest, options) {
            return localVarFp.ordersCreateOrder(createOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersListOrders(facilityGroupId, changeNumber, pageSize, options) {
            return localVarFp.ordersListOrders(facilityGroupId, changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrdersApiFactory = OrdersApiFactory;
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
class OrdersApi extends base_1.BaseAPI {
    /**
     *
     * @param {CancelOrderRequest} [cancelOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersCancelOrder(cancelOrderRequest, options) {
        return exports.OrdersApiFp(this.configuration).ordersCancelOrder(cancelOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateOrderRequest} [createOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersCreateOrder(createOrderRequest, options) {
        return exports.OrdersApiFp(this.configuration).ordersCreateOrder(createOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {number} [changeNumber]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersListOrders(facilityGroupId, changeNumber, pageSize, options) {
        return exports.OrdersApiFp(this.configuration).ordersListOrders(facilityGroupId, changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrdersApi = OrdersApi;
/**
 * OrdersCommentApi - axios parameter creator
 * @export
 */
const OrdersCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CancelOrderCommentRequest} [cancelOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCancelOrdersComment: (cancelOrderCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/orders-comment/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelOrderCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateOrderCommentRequest} [createOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCreateOrdersComment: (createOrderCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/orders-comment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOrderCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.OrdersCommentApiAxiosParamCreator = OrdersCommentApiAxiosParamCreator;
/**
 * OrdersCommentApi - functional programming interface
 * @export
 */
const OrdersCommentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OrdersCommentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CancelOrderCommentRequest} [cancelOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateOrderCommentRequest} [createOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCreateOrdersComment(createOrderCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersCommentCreateOrdersComment(createOrderCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.OrdersCommentApiFp = OrdersCommentApiFp;
/**
 * OrdersCommentApi - factory interface
 * @export
 */
const OrdersCommentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OrdersCommentApiFp(configuration);
    return {
        /**
         *
         * @param {CancelOrderCommentRequest} [cancelOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options) {
            return localVarFp.ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateOrderCommentRequest} [createOrderCommentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersCommentCreateOrdersComment(createOrderCommentRequest, options) {
            return localVarFp.ordersCommentCreateOrdersComment(createOrderCommentRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrdersCommentApiFactory = OrdersCommentApiFactory;
/**
 * OrdersCommentApi - object-oriented interface
 * @export
 * @class OrdersCommentApi
 * @extends {BaseAPI}
 */
class OrdersCommentApi extends base_1.BaseAPI {
    /**
     *
     * @param {CancelOrderCommentRequest} [cancelOrderCommentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersCommentApi
     */
    ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options) {
        return exports.OrdersCommentApiFp(this.configuration).ordersCommentCancelOrdersComment(cancelOrderCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateOrderCommentRequest} [createOrderCommentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersCommentApi
     */
    ordersCommentCreateOrdersComment(createOrderCommentRequest, options) {
        return exports.OrdersCommentApiFp(this.configuration).ordersCommentCreateOrdersComment(createOrderCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrdersCommentApi = OrdersCommentApi;
/**
 * PackedPatientDayApi - axios parameter creator
 * @export
 */
const PackedPatientDayApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientDayListPackedPatientDay: (sinceChangeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/packed-day/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sinceChangeNumber !== undefined) {
                localVarQueryParameter['sinceChangeNumber'] = sinceChangeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PackedPatientDayApiAxiosParamCreator = PackedPatientDayApiAxiosParamCreator;
/**
 * PackedPatientDayApi - functional programming interface
 * @export
 */
const PackedPatientDayApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PackedPatientDayApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PackedPatientDayApiFp = PackedPatientDayApiFp;
/**
 * PackedPatientDayApi - factory interface
 * @export
 */
const PackedPatientDayApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PackedPatientDayApiFp(configuration);
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PackedPatientDayApiFactory = PackedPatientDayApiFactory;
/**
 * PackedPatientDayApi - object-oriented interface
 * @export
 * @class PackedPatientDayApi
 * @extends {BaseAPI}
 */
class PackedPatientDayApi extends base_1.BaseAPI {
    /**
     *
     * @summary List all the packed patient medication for each day in the facility.
     * @param {number} [sinceChangeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] The page size is recommended to be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackedPatientDayApi
     */
    packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options) {
        return exports.PackedPatientDayApiFp(this.configuration).packedPatientDayListPackedPatientDay(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PackedPatientDayApi = PackedPatientDayApi;
/**
 * PackedPatientPrnMedicationApi - axios parameter creator
 * @export
 */
const PackedPatientPrnMedicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientPrnMedicationListPackedPatientPrnMedication: (sinceChangeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/packed-prn/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sinceChangeNumber !== undefined) {
                localVarQueryParameter['sinceChangeNumber'] = sinceChangeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PackedPatientPrnMedicationApiAxiosParamCreator = PackedPatientPrnMedicationApiAxiosParamCreator;
/**
 * PackedPatientPrnMedicationApi - functional programming interface
 * @export
 */
const PackedPatientPrnMedicationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PackedPatientPrnMedicationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PackedPatientPrnMedicationApiFp = PackedPatientPrnMedicationApiFp;
/**
 * PackedPatientPrnMedicationApi - factory interface
 * @export
 */
const PackedPatientPrnMedicationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PackedPatientPrnMedicationApiFp(configuration);
    return {
        /**
         *
         * @summary List all the packed patient medication for each day in the facility.
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size is recommended to be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PackedPatientPrnMedicationApiFactory = PackedPatientPrnMedicationApiFactory;
/**
 * PackedPatientPrnMedicationApi - object-oriented interface
 * @export
 * @class PackedPatientPrnMedicationApi
 * @extends {BaseAPI}
 */
class PackedPatientPrnMedicationApi extends base_1.BaseAPI {
    /**
     *
     * @summary List all the packed patient medication for each day in the facility.
     * @param {number} [sinceChangeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] The page size is recommended to be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PackedPatientPrnMedicationApi
     */
    packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options) {
        return exports.PackedPatientPrnMedicationApiFp(this.configuration).packedPatientPrnMedicationListPackedPatientPrnMedication(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PackedPatientPrnMedicationApi = PackedPatientPrnMedicationApi;
/**
 * PatchManagementApi - axios parameter creator
 * @export
 */
const PatchManagementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Update patch: Change the start date of the patch schedule for a given patient\'s patch drug.  It will not change the dose time. If the patch is a weekly patch, then the day of the week will be changed to coincide with the new start date.
         * @param {UpdatePatchRequest} [updatePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchManagementUpdatePatch: (updatePatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patch-managment/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePatchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatchManagementApiAxiosParamCreator = PatchManagementApiAxiosParamCreator;
/**
 * PatchManagementApi - functional programming interface
 * @export
 */
const PatchManagementApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatchManagementApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Update patch: Change the start date of the patch schedule for a given patient\'s patch drug.  It will not change the dose time. If the patch is a weekly patch, then the day of the week will be changed to coincide with the new start date.
         * @param {UpdatePatchRequest} [updatePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchManagementUpdatePatch(updatePatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchManagementUpdatePatch(updatePatchRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatchManagementApiFp = PatchManagementApiFp;
/**
 * PatchManagementApi - factory interface
 * @export
 */
const PatchManagementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatchManagementApiFp(configuration);
    return {
        /**
         *
         * @summary Update patch: Change the start date of the patch schedule for a given patient\'s patch drug.  It will not change the dose time. If the patch is a weekly patch, then the day of the week will be changed to coincide with the new start date.
         * @param {UpdatePatchRequest} [updatePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchManagementUpdatePatch(updatePatchRequest, options) {
            return localVarFp.patchManagementUpdatePatch(updatePatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatchManagementApiFactory = PatchManagementApiFactory;
/**
 * PatchManagementApi - object-oriented interface
 * @export
 * @class PatchManagementApi
 * @extends {BaseAPI}
 */
class PatchManagementApi extends base_1.BaseAPI {
    /**
     *
     * @summary Update patch: Change the start date of the patch schedule for a given patient\'s patch drug.  It will not change the dose time. If the patch is a weekly patch, then the day of the week will be changed to coincide with the new start date.
     * @param {UpdatePatchRequest} [updatePatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatchManagementApi
     */
    patchManagementUpdatePatch(updatePatchRequest, options) {
        return exports.PatchManagementApiFp(this.configuration).patchManagementUpdatePatch(updatePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatchManagementApi = PatchManagementApi;
/**
 * PatchObservationsApi - axios parameter creator
 * @export
 */
const PatchObservationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreatePatchObservationsReq} [createPatchObservationsReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsCreatePatchObservation: (createPatchObservationsReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patch-observations/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPatchObservationsReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all the rounds in a facility
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsListPatchObservations: (changeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patch-observations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatchObservationsApiAxiosParamCreator = PatchObservationsApiAxiosParamCreator;
/**
 * PatchObservationsApi - functional programming interface
 * @export
 */
const PatchObservationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatchObservationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreatePatchObservationsReq} [createPatchObservationsReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsCreatePatchObservation(createPatchObservationsReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchObservationsCreatePatchObservation(createPatchObservationsReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all the rounds in a facility
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatchObservationsApiFp = PatchObservationsApiFp;
/**
 * PatchObservationsApi - factory interface
 * @export
 */
const PatchObservationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatchObservationsApiFp(configuration);
    return {
        /**
         *
         * @param {CreatePatchObservationsReq} [createPatchObservationsReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsCreatePatchObservation(createPatchObservationsReq, options) {
            return localVarFp.patchObservationsCreatePatchObservation(createPatchObservationsReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all the rounds in a facility
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatchObservationsApiFactory = PatchObservationsApiFactory;
/**
 * PatchObservationsApi - object-oriented interface
 * @export
 * @class PatchObservationsApi
 * @extends {BaseAPI}
 */
class PatchObservationsApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreatePatchObservationsReq} [createPatchObservationsReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatchObservationsApi
     */
    patchObservationsCreatePatchObservation(createPatchObservationsReq, options) {
        return exports.PatchObservationsApiFp(this.configuration).patchObservationsCreatePatchObservation(createPatchObservationsReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all the rounds in a facility
     * @param {number} [changeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatchObservationsApi
     */
    patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options) {
        return exports.PatchObservationsApiFp(this.configuration).patchObservationsListPatchObservations(changeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatchObservationsApi = PatchObservationsApi;
/**
 * PatientMedicationApi - axios parameter creator
 * @export
 */
const PatientMedicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Updates the self administered status of a medication for a specific patient
         * @param {PatientMedicationUpdateRequest} [patientMedicationUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMedicationUpdateSelfAdministeredStatus: (patientMedicationUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patient-medication/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(patientMedicationUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatientMedicationApiAxiosParamCreator = PatientMedicationApiAxiosParamCreator;
/**
 * PatientMedicationApi - functional programming interface
 * @export
 */
const PatientMedicationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatientMedicationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Updates the self administered status of a medication for a specific patient
         * @param {PatientMedicationUpdateRequest} [patientMedicationUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatientMedicationApiFp = PatientMedicationApiFp;
/**
 * PatientMedicationApi - factory interface
 * @export
 */
const PatientMedicationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatientMedicationApiFp(configuration);
    return {
        /**
         *
         * @summary Updates the self administered status of a medication for a specific patient
         * @param {PatientMedicationUpdateRequest} [patientMedicationUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options) {
            return localVarFp.patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatientMedicationApiFactory = PatientMedicationApiFactory;
/**
 * PatientMedicationApi - object-oriented interface
 * @export
 * @class PatientMedicationApi
 * @extends {BaseAPI}
 */
class PatientMedicationApi extends base_1.BaseAPI {
    /**
     *
     * @summary Updates the self administered status of a medication for a specific patient
     * @param {PatientMedicationUpdateRequest} [patientMedicationUpdateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMedicationApi
     */
    patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options) {
        return exports.PatientMedicationApiFp(this.configuration).patientMedicationUpdateSelfAdministeredStatus(patientMedicationUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatientMedicationApi = PatientMedicationApi;
/**
 * PatientMovementsApi - axios parameter creator
 * @export
 */
const PatientMovementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMovementsListPatientMovements: (facilityGroupId, changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patient-movements/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatientMovementsApiAxiosParamCreator = PatientMovementsApiAxiosParamCreator;
/**
 * PatientMovementsApi - functional programming interface
 * @export
 */
const PatientMovementsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatientMovementsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatientMovementsApiFp = PatientMovementsApiFp;
/**
 * PatientMovementsApi - factory interface
 * @export
 */
const PatientMovementsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatientMovementsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options) {
            return localVarFp.patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatientMovementsApiFactory = PatientMovementsApiFactory;
/**
 * PatientMovementsApi - object-oriented interface
 * @export
 * @class PatientMovementsApi
 * @extends {BaseAPI}
 */
class PatientMovementsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {number} [changeNumber]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientMovementsApi
     */
    patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options) {
        return exports.PatientMovementsApiFp(this.configuration).patientMovementsListPatientMovements(facilityGroupId, changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatientMovementsApi = PatientMovementsApi;
/**
 * PatientProgressNoteApi - axios parameter creator
 * @export
 */
const PatientProgressNoteApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateHsPatientProgressNoteReq} [createHsPatientProgressNoteReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteCreateNote: (createHsPatientProgressNoteReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patient-progress-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createHsPatientProgressNoteReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [patientId]
         * @param {number} [facilityGroupId]
         * @param {any} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteUploadFile: (patientId, facilityGroupId, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/upload_attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (patientId !== undefined) {
                localVarFormParams.append('patient_id', patientId);
            }
            if (facilityGroupId !== undefined) {
                localVarFormParams.append('facility_group_id', facilityGroupId);
            }
            if (attachment !== undefined) {
                localVarFormParams.append('attachment', attachment);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {string} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteViewAttachment: (facilityGroupId, patientId, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('patientProgressNoteViewAttachment', 'facilityGroupId', facilityGroupId);
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('patientProgressNoteViewAttachment', 'patientId', patientId);
            // verify required parameter 'attachment' is not null or undefined
            common_1.assertParamExists('patientProgressNoteViewAttachment', 'attachment', attachment);
            const localVarPath = `/facility-group/{facility_group_id}/resident-details/{patient_id}/attachments/{attachment}`
                .replace(`{${"facility_group_id"}}`, encodeURIComponent(String(facilityGroupId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"attachment"}}`, encodeURIComponent(String(attachment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatientProgressNoteApiAxiosParamCreator = PatientProgressNoteApiAxiosParamCreator;
/**
 * PatientProgressNoteApi - functional programming interface
 * @export
 */
const PatientProgressNoteApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatientProgressNoteApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateHsPatientProgressNoteReq} [createHsPatientProgressNoteReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [patientId]
         * @param {number} [facilityGroupId]
         * @param {any} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {string} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatientProgressNoteApiFp = PatientProgressNoteApiFp;
/**
 * PatientProgressNoteApi - factory interface
 * @export
 */
const PatientProgressNoteApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatientProgressNoteApiFp(configuration);
    return {
        /**
         *
         * @param {CreateHsPatientProgressNoteReq} [createHsPatientProgressNoteReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options) {
            return localVarFp.patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [patientId]
         * @param {number} [facilityGroupId]
         * @param {any} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options) {
            return localVarFp.patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {string} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options) {
            return localVarFp.patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatientProgressNoteApiFactory = PatientProgressNoteApiFactory;
/**
 * PatientProgressNoteApi - object-oriented interface
 * @export
 * @class PatientProgressNoteApi
 * @extends {BaseAPI}
 */
class PatientProgressNoteApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateHsPatientProgressNoteReq} [createHsPatientProgressNoteReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientProgressNoteApi
     */
    patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options) {
        return exports.PatientProgressNoteApiFp(this.configuration).patientProgressNoteCreateNote(createHsPatientProgressNoteReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [patientId]
     * @param {number} [facilityGroupId]
     * @param {any} [attachment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientProgressNoteApi
     */
    patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options) {
        return exports.PatientProgressNoteApiFp(this.configuration).patientProgressNoteUploadFile(patientId, facilityGroupId, attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} facilityGroupId
     * @param {number} patientId
     * @param {string} attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientProgressNoteApi
     */
    patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options) {
        return exports.PatientProgressNoteApiFp(this.configuration).patientProgressNoteViewAttachment(facilityGroupId, patientId, attachment, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatientProgressNoteApi = PatientProgressNoteApi;
/**
 * PatientsApi - axios parameter creator
 * @export
 */
const PatientsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsListPatients: (facilityGroupId, changeNumber, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patients/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsMhrPage: (facilityGroupId, patientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('patientsMhrPage', 'facilityGroupId', facilityGroupId);
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('patientsMhrPage', 'patientId', patientId);
            const localVarPath = `/patients/{facilityGroupId}/{patientId}/mhr`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdatePatientReq} [updatePatientReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsUpdate: (updatePatientReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/patients/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePatientReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PatientsApiAxiosParamCreator = PatientsApiAxiosParamCreator;
/**
 * PatientsApi - functional programming interface
 * @export
 */
const PatientsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PatientsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsListPatients(facilityGroupId, changeNumber, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientsListPatients(facilityGroupId, changeNumber, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsMhrPage(facilityGroupId, patientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientsMhrPage(facilityGroupId, patientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdatePatientReq} [updatePatientReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsUpdate(updatePatientReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patientsUpdate(updatePatientReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PatientsApiFp = PatientsApiFp;
/**
 * PatientsApi - factory interface
 * @export
 */
const PatientsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PatientsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {number} [changeNumber]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsListPatients(facilityGroupId, changeNumber, pageSize, options) {
            return localVarFp.patientsListPatients(facilityGroupId, changeNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {number} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsMhrPage(facilityGroupId, patientId, options) {
            return localVarFp.patientsMhrPage(facilityGroupId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdatePatientReq} [updatePatientReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsUpdate(updatePatientReq, options) {
            return localVarFp.patientsUpdate(updatePatientReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PatientsApiFactory = PatientsApiFactory;
/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
class PatientsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {number} [changeNumber]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    patientsListPatients(facilityGroupId, changeNumber, pageSize, options) {
        return exports.PatientsApiFp(this.configuration).patientsListPatients(facilityGroupId, changeNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} facilityGroupId
     * @param {number} patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    patientsMhrPage(facilityGroupId, patientId, options) {
        return exports.PatientsApiFp(this.configuration).patientsMhrPage(facilityGroupId, patientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdatePatientReq} [updatePatientReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    patientsUpdate(updatePatientReq, options) {
        return exports.PatientsApiFp(this.configuration).patientsUpdate(updatePatientReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PatientsApi = PatientsApi;
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsCanAccess: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/permissions/can-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGlobalPermissions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/permissions/my-global-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGroupPermissions: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/permissions/my-group-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PermissionsApiAxiosParamCreator = PermissionsApiAxiosParamCreator;
/**
 * PermissionsApi - functional programming interface
 * @export
 */
const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsCanAccess(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.permissionsCanAccess(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGlobalPermissions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.permissionsMyGlobalPermissions(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGroupPermissions(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.permissionsMyGroupPermissions(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PermissionsApiFp = PermissionsApiFp;
/**
 * PermissionsApi - factory interface
 * @export
 */
const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PermissionsApiFp(configuration);
    return {
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsCanAccess(facilityGroupId, options) {
            return localVarFp.permissionsCanAccess(facilityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGlobalPermissions(options) {
            return localVarFp.permissionsMyGlobalPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsMyGroupPermissions(facilityGroupId, options) {
            return localVarFp.permissionsMyGroupPermissions(facilityGroupId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PermissionsApiFactory = PermissionsApiFactory;
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
class PermissionsApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsCanAccess(facilityGroupId, options) {
        return exports.PermissionsApiFp(this.configuration).permissionsCanAccess(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsMyGlobalPermissions(options) {
        return exports.PermissionsApiFp(this.configuration).permissionsMyGlobalPermissions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    permissionsMyGroupPermissions(facilityGroupId, options) {
        return exports.PermissionsApiFp(this.configuration).permissionsMyGroupPermissions(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PermissionsApi = PermissionsApi;
/**
 * ReportingApi - axios parameter creator
 * @export
 */
const ReportingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns Embed token and list of reports for a given facility group
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportingGetEmbedInfo: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reporting/embedInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ReportingApiAxiosParamCreator = ReportingApiAxiosParamCreator;
/**
 * ReportingApi - functional programming interface
 * @export
 */
const ReportingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ReportingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns Embed token and list of reports for a given facility group
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportingGetEmbedInfo(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportingGetEmbedInfo(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ReportingApiFp = ReportingApiFp;
/**
 * ReportingApi - factory interface
 * @export
 */
const ReportingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ReportingApiFp(configuration);
    return {
        /**
         *
         * @summary Returns Embed token and list of reports for a given facility group
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportingGetEmbedInfo(facilityGroupId, options) {
            return localVarFp.reportingGetEmbedInfo(facilityGroupId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ReportingApiFactory = ReportingApiFactory;
/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
class ReportingApi extends base_1.BaseAPI {
    /**
     *
     * @summary Returns Embed token and list of reports for a given facility group
     * @param {number} [facilityGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingApi
     */
    reportingGetEmbedInfo(facilityGroupId, options) {
        return exports.ReportingApiFp(this.configuration).reportingGetEmbedInfo(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ReportingApi = ReportingApi;
/**
 * RoleApi - axios parameter creator
 * @export
 */
const RoleApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleGetAll: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('roleGetAll', 'facilityGroupId', facilityGroupId);
            const localVarPath = `/roles/{facilityGroupId}`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RoleApiAxiosParamCreator = RoleApiAxiosParamCreator;
/**
 * RoleApi - functional programming interface
 * @export
 */
const RoleApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RoleApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleGetAll(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roleGetAll(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RoleApiFp = RoleApiFp;
/**
 * RoleApi - factory interface
 * @export
 */
const RoleApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RoleApiFp(configuration);
    return {
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleGetAll(facilityGroupId, options) {
            return localVarFp.roleGetAll(facilityGroupId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RoleApiFactory = RoleApiFactory;
/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
class RoleApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} facilityGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    roleGetAll(facilityGroupId, options) {
        return exports.RoleApiFp(this.configuration).roleGetAll(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RoleApi = RoleApi;
/**
 * RoundSegmentApi - axios parameter creator
 * @export
 */
const RoundSegmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a round segment for a round
         * @param {CreateRoundSegmentReq} [createRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentCreate: (createRoundSegmentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/round-segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createRoundSegmentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary update a round segment
         * @param {UpdateRoundSegmentReq} [updateRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentUpdate: (updateRoundSegmentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/round-segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateRoundSegmentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RoundSegmentApiAxiosParamCreator = RoundSegmentApiAxiosParamCreator;
/**
 * RoundSegmentApi - functional programming interface
 * @export
 */
const RoundSegmentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RoundSegmentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a round segment for a round
         * @param {CreateRoundSegmentReq} [createRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentCreate(createRoundSegmentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundSegmentCreate(createRoundSegmentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary update a round segment
         * @param {UpdateRoundSegmentReq} [updateRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentUpdate(updateRoundSegmentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundSegmentUpdate(updateRoundSegmentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RoundSegmentApiFp = RoundSegmentApiFp;
/**
 * RoundSegmentApi - factory interface
 * @export
 */
const RoundSegmentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RoundSegmentApiFp(configuration);
    return {
        /**
         *
         * @summary Create a round segment for a round
         * @param {CreateRoundSegmentReq} [createRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentCreate(createRoundSegmentReq, options) {
            return localVarFp.roundSegmentCreate(createRoundSegmentReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary update a round segment
         * @param {UpdateRoundSegmentReq} [updateRoundSegmentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundSegmentUpdate(updateRoundSegmentReq, options) {
            return localVarFp.roundSegmentUpdate(updateRoundSegmentReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RoundSegmentApiFactory = RoundSegmentApiFactory;
/**
 * RoundSegmentApi - object-oriented interface
 * @export
 * @class RoundSegmentApi
 * @extends {BaseAPI}
 */
class RoundSegmentApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create a round segment for a round
     * @param {CreateRoundSegmentReq} [createRoundSegmentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundSegmentApi
     */
    roundSegmentCreate(createRoundSegmentReq, options) {
        return exports.RoundSegmentApiFp(this.configuration).roundSegmentCreate(createRoundSegmentReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary update a round segment
     * @param {UpdateRoundSegmentReq} [updateRoundSegmentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundSegmentApi
     */
    roundSegmentUpdate(updateRoundSegmentReq, options) {
        return exports.RoundSegmentApiFp(this.configuration).roundSegmentUpdate(updateRoundSegmentReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RoundSegmentApi = RoundSegmentApi;
/**
 * RoundsApi - axios parameter creator
 * @export
 */
const RoundsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Complete a round
         * @param {CompleteRoundReq} [completeRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCompleteRound: (completeRoundReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/rounds/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(completeRoundReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a round
         * @param {CreateRoundReq} [createRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCreateRound: (createRoundReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/rounds/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createRoundReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsListRounds: (sinceChangeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/rounds/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sinceChangeNumber !== undefined) {
                localVarQueryParameter['sinceChangeNumber'] = sinceChangeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Starts a round
         * @param {StartRoundReq} [startRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsStartRound: (startRoundReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/rounds/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(startRoundReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RoundsApiAxiosParamCreator = RoundsApiAxiosParamCreator;
/**
 * RoundsApi - functional programming interface
 * @export
 */
const RoundsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.RoundsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Complete a round
         * @param {CompleteRoundReq} [completeRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCompleteRound(completeRoundReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundsCompleteRound(completeRoundReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a round
         * @param {CreateRoundReq} [createRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCreateRound(createRoundReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundsCreateRound(createRoundReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Starts a round
         * @param {StartRoundReq} [startRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsStartRound(startRoundReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roundsStartRound(startRoundReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RoundsApiFp = RoundsApiFp;
/**
 * RoundsApi - factory interface
 * @export
 */
const RoundsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.RoundsApiFp(configuration);
    return {
        /**
         *
         * @summary Complete a round
         * @param {CompleteRoundReq} [completeRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCompleteRound(completeRoundReq, options) {
            return localVarFp.roundsCompleteRound(completeRoundReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a round
         * @param {CreateRoundReq} [createRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsCreateRound(createRoundReq, options) {
            return localVarFp.roundsCreateRound(createRoundReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Starts a round
         * @param {StartRoundReq} [startRoundReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roundsStartRound(startRoundReq, options) {
            return localVarFp.roundsStartRound(startRoundReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RoundsApiFactory = RoundsApiFactory;
/**
 * RoundsApi - object-oriented interface
 * @export
 * @class RoundsApi
 * @extends {BaseAPI}
 */
class RoundsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Complete a round
     * @param {CompleteRoundReq} [completeRoundReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundsApi
     */
    roundsCompleteRound(completeRoundReq, options) {
        return exports.RoundsApiFp(this.configuration).roundsCompleteRound(completeRoundReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a round
     * @param {CreateRoundReq} [createRoundReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundsApi
     */
    roundsCreateRound(createRoundReq, options) {
        return exports.RoundsApiFp(this.configuration).roundsCreateRound(createRoundReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [sinceChangeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundsApi
     */
    roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options) {
        return exports.RoundsApiFp(this.configuration).roundsListRounds(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Starts a round
     * @param {StartRoundReq} [startRoundReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoundsApi
     */
    roundsStartRound(startRoundReq, options) {
        return exports.RoundsApiFp(this.configuration).roundsStartRound(startRoundReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RoundsApi = RoundsApi;
/**
 * SecondCheckSettingApi - axios parameter creator
 * @export
 */
const SecondCheckSettingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateCategory: (createSecondCheckSettingReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/second-check-setting/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSecondCheckSettingReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateDrug: (createSecondCheckSettingReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/second-check-setting/drug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSecondCheckSettingReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateRoute: (createSecondCheckSettingReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/second-check-setting/route`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSecondCheckSettingReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeleteSecondCheckSetting} [deleteSecondCheckSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingDelete: (deleteSecondCheckSetting, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/second-check-setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deleteSecondCheckSetting, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingList: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('secondCheckSettingList', 'facilityGroupId', facilityGroupId);
            const localVarPath = `/second-check-setting/{facilityGroupId}`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SecondCheckSettingApiAxiosParamCreator = SecondCheckSettingApiAxiosParamCreator;
/**
 * SecondCheckSettingApi - functional programming interface
 * @export
 */
const SecondCheckSettingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SecondCheckSettingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateCategory(createSecondCheckSettingReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.secondCheckSettingCreateCategory(createSecondCheckSettingReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateDrug(createSecondCheckSettingReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.secondCheckSettingCreateDrug(createSecondCheckSettingReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateRoute(createSecondCheckSettingReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.secondCheckSettingCreateRoute(createSecondCheckSettingReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {DeleteSecondCheckSetting} [deleteSecondCheckSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingDelete(deleteSecondCheckSetting, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.secondCheckSettingDelete(deleteSecondCheckSetting, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingList(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.secondCheckSettingList(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SecondCheckSettingApiFp = SecondCheckSettingApiFp;
/**
 * SecondCheckSettingApi - factory interface
 * @export
 */
const SecondCheckSettingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SecondCheckSettingApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateCategory(createSecondCheckSettingReq, options) {
            return localVarFp.secondCheckSettingCreateCategory(createSecondCheckSettingReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateDrug(createSecondCheckSettingReq, options) {
            return localVarFp.secondCheckSettingCreateDrug(createSecondCheckSettingReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingCreateRoute(createSecondCheckSettingReq, options) {
            return localVarFp.secondCheckSettingCreateRoute(createSecondCheckSettingReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DeleteSecondCheckSetting} [deleteSecondCheckSetting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingDelete(deleteSecondCheckSetting, options) {
            return localVarFp.secondCheckSettingDelete(deleteSecondCheckSetting, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secondCheckSettingList(facilityGroupId, options) {
            return localVarFp.secondCheckSettingList(facilityGroupId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SecondCheckSettingApiFactory = SecondCheckSettingApiFactory;
/**
 * SecondCheckSettingApi - object-oriented interface
 * @export
 * @class SecondCheckSettingApi
 * @extends {BaseAPI}
 */
class SecondCheckSettingApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondCheckSettingApi
     */
    secondCheckSettingCreateCategory(createSecondCheckSettingReq, options) {
        return exports.SecondCheckSettingApiFp(this.configuration).secondCheckSettingCreateCategory(createSecondCheckSettingReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondCheckSettingApi
     */
    secondCheckSettingCreateDrug(createSecondCheckSettingReq, options) {
        return exports.SecondCheckSettingApiFp(this.configuration).secondCheckSettingCreateDrug(createSecondCheckSettingReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateSecondCheckSettingReq} [createSecondCheckSettingReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondCheckSettingApi
     */
    secondCheckSettingCreateRoute(createSecondCheckSettingReq, options) {
        return exports.SecondCheckSettingApiFp(this.configuration).secondCheckSettingCreateRoute(createSecondCheckSettingReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DeleteSecondCheckSetting} [deleteSecondCheckSetting]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondCheckSettingApi
     */
    secondCheckSettingDelete(deleteSecondCheckSetting, options) {
        return exports.SecondCheckSettingApiFp(this.configuration).secondCheckSettingDelete(deleteSecondCheckSetting, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} facilityGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecondCheckSettingApi
     */
    secondCheckSettingList(facilityGroupId, options) {
        return exports.SecondCheckSettingApiFp(this.configuration).secondCheckSettingList(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SecondCheckSettingApi = SecondCheckSettingApi;
/**
 * SessionApi - axios parameter creator
 * @export
 */
const SessionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SessionApiAxiosParamCreator = SessionApiAxiosParamCreator;
/**
 * SessionApi - functional programming interface
 * @export
 */
const SessionApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SessionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionCreate(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SessionApiFp = SessionApiFp;
/**
 * SessionApi - factory interface
 * @export
 */
const SessionApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SessionApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate(options) {
            return localVarFp.sessionCreate(options).then((request) => request(axios, basePath));
        },
    };
};
exports.SessionApiFactory = SessionApiFactory;
/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
class SessionApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create a new session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionApi
     */
    sessionCreate(options) {
        return exports.SessionApiFp(this.configuration).sessionCreate(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SessionApi = SessionApi;
/**
 * SyringeDriverActivitiesApi - axios parameter creator
 * @export
 */
const SyringeDriverActivitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityReq} [createSyringeDriverActivityReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesCreateSyringeDriverActivity: (createSyringeDriverActivityReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/syringe-driver-activities/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSyringeDriverActivityReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesListSyringeDriverActivities: (changeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/syringe-driver-activities/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (changeNumber !== undefined) {
                localVarQueryParameter['changeNumber'] = changeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SyringeDriverActivitiesApiAxiosParamCreator = SyringeDriverActivitiesApiAxiosParamCreator;
/**
 * SyringeDriverActivitiesApi - functional programming interface
 * @export
 */
const SyringeDriverActivitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SyringeDriverActivitiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityReq} [createSyringeDriverActivityReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SyringeDriverActivitiesApiFp = SyringeDriverActivitiesApiFp;
/**
 * SyringeDriverActivitiesApi - factory interface
 * @export
 */
const SyringeDriverActivitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SyringeDriverActivitiesApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityReq} [createSyringeDriverActivityReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options) {
            return localVarFp.syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [changeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] The page size could be 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SyringeDriverActivitiesApiFactory = SyringeDriverActivitiesApiFactory;
/**
 * SyringeDriverActivitiesApi - object-oriented interface
 * @export
 * @class SyringeDriverActivitiesApi
 * @extends {BaseAPI}
 */
class SyringeDriverActivitiesApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateSyringeDriverActivityReq} [createSyringeDriverActivityReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyringeDriverActivitiesApi
     */
    syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options) {
        return exports.SyringeDriverActivitiesApiFp(this.configuration).syringeDriverActivitiesCreateSyringeDriverActivity(createSyringeDriverActivityReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [changeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] The page size could be 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyringeDriverActivitiesApi
     */
    syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options) {
        return exports.SyringeDriverActivitiesApiFp(this.configuration).syringeDriverActivitiesListSyringeDriverActivities(changeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SyringeDriverActivitiesApi = SyringeDriverActivitiesApi;
/**
 * SyringeDriverActivityCommentsApi - axios parameter creator
 * @export
 */
const SyringeDriverActivityCommentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityCommentReq} [createSyringeDriverActivityCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivityCommentsCreateSyringeDriverActivityComment: (createSyringeDriverActivityCommentReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/syringe-driver-activity-comments/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createSyringeDriverActivityCommentReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SyringeDriverActivityCommentsApiAxiosParamCreator = SyringeDriverActivityCommentsApiAxiosParamCreator;
/**
 * SyringeDriverActivityCommentsApi - functional programming interface
 * @export
 */
const SyringeDriverActivityCommentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SyringeDriverActivityCommentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityCommentReq} [createSyringeDriverActivityCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SyringeDriverActivityCommentsApiFp = SyringeDriverActivityCommentsApiFp;
/**
 * SyringeDriverActivityCommentsApi - factory interface
 * @export
 */
const SyringeDriverActivityCommentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SyringeDriverActivityCommentsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateSyringeDriverActivityCommentReq} [createSyringeDriverActivityCommentReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options) {
            return localVarFp.syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SyringeDriverActivityCommentsApiFactory = SyringeDriverActivityCommentsApiFactory;
/**
 * SyringeDriverActivityCommentsApi - object-oriented interface
 * @export
 * @class SyringeDriverActivityCommentsApi
 * @extends {BaseAPI}
 */
class SyringeDriverActivityCommentsApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateSyringeDriverActivityCommentReq} [createSyringeDriverActivityCommentReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyringeDriverActivityCommentsApi
     */
    syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options) {
        return exports.SyringeDriverActivityCommentsApiFp(this.configuration).syringeDriverActivityCommentsCreateSyringeDriverActivityComment(createSyringeDriverActivityCommentReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SyringeDriverActivityCommentsApi = SyringeDriverActivityCommentsApi;
/**
 * TestResultApi - axios parameter creator
 * @export
 */
const TestResultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary create a test result
         * @param {CreateTestResultReq} [createTestResultReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultCreate: (createTestResultReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/test-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createTestResultReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all the test results in a facility
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultList: (sinceChangeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/test-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sinceChangeNumber !== undefined) {
                localVarQueryParameter['sinceChangeNumber'] = sinceChangeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all the test results in a facility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultListTestResultType: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/test-result/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TestResultApiAxiosParamCreator = TestResultApiAxiosParamCreator;
/**
 * TestResultApi - functional programming interface
 * @export
 */
const TestResultApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TestResultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary create a test result
         * @param {CreateTestResultReq} [createTestResultReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultCreate(createTestResultReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultCreate(createTestResultReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all the test results in a facility
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultList(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultList(sinceChangeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all the test results in a facility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultListTestResultType(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.testResultListTestResultType(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TestResultApiFp = TestResultApiFp;
/**
 * TestResultApi - factory interface
 * @export
 */
const TestResultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TestResultApiFp(configuration);
    return {
        /**
         *
         * @summary create a test result
         * @param {CreateTestResultReq} [createTestResultReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultCreate(createTestResultReq, options) {
            return localVarFp.testResultCreate(createTestResultReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all the test results in a facility
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 200
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultList(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.testResultList(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all the test results in a facility
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testResultListTestResultType(options) {
            return localVarFp.testResultListTestResultType(options).then((request) => request(axios, basePath));
        },
    };
};
exports.TestResultApiFactory = TestResultApiFactory;
/**
 * TestResultApi - object-oriented interface
 * @export
 * @class TestResultApi
 * @extends {BaseAPI}
 */
class TestResultApi extends base_1.BaseAPI {
    /**
     *
     * @summary create a test result
     * @param {CreateTestResultReq} [createTestResultReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultApi
     */
    testResultCreate(createTestResultReq, options) {
        return exports.TestResultApiFp(this.configuration).testResultCreate(createTestResultReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all the test results in a facility
     * @param {number} [sinceChangeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] the default page size is 200
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultApi
     */
    testResultList(sinceChangeNumber, facilityGroupId, pageSize, options) {
        return exports.TestResultApiFp(this.configuration).testResultList(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all the test results in a facility
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResultApi
     */
    testResultListTestResultType(options) {
        return exports.TestResultApiFp(this.configuration).testResultListTestResultType(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TestResultApi = TestResultApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [userInvitationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteSubject: (userInvitationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/subject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (userInvitationId !== undefined) {
                localVarQueryParameter['userInvitationId'] = userInvitationId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get the current hs user from the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetCurrentUser: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/hs-user/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPinUsers: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/pin-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitationById: (invitationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'invitationId' is not null or undefined
            common_1.assertParamExists('userGetUserInvitationById', 'invitationId', invitationId);
            const localVarPath = `/users/invitations/{invitationId}`
                .replace(`{${"invitationId"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitations: (facilityGroupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'facilityGroupId' is not null or undefined
            common_1.assertParamExists('userGetUserInvitations', 'facilityGroupId', facilityGroupId);
            const localVarPath = `/users/invitations/facility-group/{facilityGroupId}`
                .replace(`{${"facilityGroupId"}}`, encodeURIComponent(String(facilityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary check whether the logged in user has pin set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userIfPinExists: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/pin/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UserOnboardSingleReq} [userOnboardSingleReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInviteUser: (userOnboardSingleReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(userOnboardSingleReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary get a list of users by facility group
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 500
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListUsers: (sinceChangeNumber, facilityGroupId, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (sinceChangeNumber !== undefined) {
                localVarQueryParameter['sinceChangeNumber'] = sinceChangeNumber;
            }
            if (facilityGroupId !== undefined) {
                localVarQueryParameter['facilityGroupId'] = facilityGroupId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} hashcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userOnboardUser: (hashcode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'hashcode' is not null or undefined
            common_1.assertParamExists('userOnboardUser', 'hashcode', hashcode);
            const localVarPath = `/users/invitation/accept/{hashcode}`
                .replace(`{${"hashcode"}}`, encodeURIComponent(String(hashcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateUserInvitationReq} [updateUserInvitationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateUserInvitation: (updateUserInvitationReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUserInvitationReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create or update a pin for the logged in user
         * @param {CreateOrUpdatePinReq} [createOrUpdatePinReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpsertPin: (createOrUpdatePinReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/pin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createOrUpdatePinReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UserApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [userInvitationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteSubject(userInvitationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userDeleteSubject(userInvitationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get the current hs user from the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetCurrentUser(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetCurrentUser(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPinUsers(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetPinUsers(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitationById(invitationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetUserInvitationById(invitationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitations(facilityGroupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetUserInvitations(facilityGroupId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary check whether the logged in user has pin set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userIfPinExists(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userIfPinExists(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UserOnboardSingleReq} [userOnboardSingleReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInviteUser(userOnboardSingleReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userInviteUser(userOnboardSingleReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary get a list of users by facility group
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 500
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} hashcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userOnboardUser(hashcode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userOnboardUser(hashcode, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdateUserInvitationReq} [updateUserInvitationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateUserInvitation(updateUserInvitationReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userUpdateUserInvitation(updateUserInvitationReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create or update a pin for the logged in user
         * @param {CreateOrUpdatePinReq} [createOrUpdatePinReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpsertPin(createOrUpdatePinReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userUpsertPin(createOrUpdatePinReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UserApiFp(configuration);
    return {
        /**
         *
         * @param {number} [userInvitationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDeleteSubject(userInvitationId, options) {
            return localVarFp.userDeleteSubject(userInvitationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get the current hs user from the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetCurrentUser(options) {
            return localVarFp.userGetCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [facilityGroupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPinUsers(facilityGroupId, options) {
            return localVarFp.userGetPinUsers(facilityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} invitationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitationById(invitationId, options) {
            return localVarFp.userGetUserInvitationById(invitationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} facilityGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetUserInvitations(facilityGroupId, options) {
            return localVarFp.userGetUserInvitations(facilityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary check whether the logged in user has pin set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userIfPinExists(options) {
            return localVarFp.userIfPinExists(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserOnboardSingleReq} [userOnboardSingleReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInviteUser(userOnboardSingleReq, options) {
            return localVarFp.userInviteUser(userOnboardSingleReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary get a list of users by facility group
         * @param {number} [sinceChangeNumber]
         * @param {number} [facilityGroupId]
         * @param {number} [pageSize] the default page size is 500
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options) {
            return localVarFp.userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} hashcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userOnboardUser(hashcode, options) {
            return localVarFp.userOnboardUser(hashcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateUserInvitationReq} [updateUserInvitationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateUserInvitation(updateUserInvitationReq, options) {
            return localVarFp.userUpdateUserInvitation(updateUserInvitationReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create or update a pin for the logged in user
         * @param {CreateOrUpdatePinReq} [createOrUpdatePinReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpsertPin(createOrUpdatePinReq, options) {
            return localVarFp.userUpsertPin(createOrUpdatePinReq, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
class UserApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [userInvitationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userDeleteSubject(userInvitationId, options) {
        return exports.UserApiFp(this.configuration).userDeleteSubject(userInvitationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get the current hs user from the logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userGetCurrentUser(options) {
        return exports.UserApiFp(this.configuration).userGetCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [facilityGroupId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userGetPinUsers(facilityGroupId, options) {
        return exports.UserApiFp(this.configuration).userGetPinUsers(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userGetUserInvitationById(invitationId, options) {
        return exports.UserApiFp(this.configuration).userGetUserInvitationById(invitationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} facilityGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userGetUserInvitations(facilityGroupId, options) {
        return exports.UserApiFp(this.configuration).userGetUserInvitations(facilityGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary check whether the logged in user has pin set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userIfPinExists(options) {
        return exports.UserApiFp(this.configuration).userIfPinExists(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserOnboardSingleReq} [userOnboardSingleReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userInviteUser(userOnboardSingleReq, options) {
        return exports.UserApiFp(this.configuration).userInviteUser(userOnboardSingleReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary get a list of users by facility group
     * @param {number} [sinceChangeNumber]
     * @param {number} [facilityGroupId]
     * @param {number} [pageSize] the default page size is 500
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options) {
        return exports.UserApiFp(this.configuration).userListUsers(sinceChangeNumber, facilityGroupId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} hashcode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userOnboardUser(hashcode, options) {
        return exports.UserApiFp(this.configuration).userOnboardUser(hashcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UpdateUserInvitationReq} [updateUserInvitationReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userUpdateUserInvitation(updateUserInvitationReq, options) {
        return exports.UserApiFp(this.configuration).userUpdateUserInvitation(updateUserInvitationReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create or update a pin for the logged in user
     * @param {CreateOrUpdatePinReq} [createOrUpdatePinReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    userUpsertPin(createOrUpdatePinReq, options) {
        return exports.UserApiFp(this.configuration).userUpsertPin(createOrUpdatePinReq, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserApi = UserApi;
/**
 * WarningDetailsApi - axios parameter creator
 * @export
 */
const WarningDetailsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateWarningDetailReq} [createWarningDetailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsCreateNewWarningDetail: (createWarningDetailReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/warning-detail/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createWarningDetailReq, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDeleteWarningDetail: (warningId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/warning-detail/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (warningId !== undefined) {
                localVarQueryParameter['warningId'] = warningId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDismissNotification: (warningId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/warning-detail/dismiss-warning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (warningId !== undefined) {
                localVarQueryParameter['warningId'] = warningId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsFetchLatestWarningDetail: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/warning-detail/fetch-latest-warning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsListWarningDetails: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/warning-detail/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WarningDetailsApiAxiosParamCreator = WarningDetailsApiAxiosParamCreator;
/**
 * WarningDetailsApi - functional programming interface
 * @export
 */
const WarningDetailsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.WarningDetailsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateWarningDetailReq} [createWarningDetailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsCreateNewWarningDetail(createWarningDetailReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.warningDetailsCreateNewWarningDetail(createWarningDetailReq, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDeleteWarningDetail(warningId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.warningDetailsDeleteWarningDetail(warningId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDismissNotification(warningId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.warningDetailsDismissNotification(warningId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsFetchLatestWarningDetail(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.warningDetailsFetchLatestWarningDetail(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsListWarningDetails(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.warningDetailsListWarningDetails(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WarningDetailsApiFp = WarningDetailsApiFp;
/**
 * WarningDetailsApi - factory interface
 * @export
 */
const WarningDetailsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.WarningDetailsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateWarningDetailReq} [createWarningDetailReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsCreateNewWarningDetail(createWarningDetailReq, options) {
            return localVarFp.warningDetailsCreateNewWarningDetail(createWarningDetailReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDeleteWarningDetail(warningId, options) {
            return localVarFp.warningDetailsDeleteWarningDetail(warningId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [warningId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsDismissNotification(warningId, options) {
            return localVarFp.warningDetailsDismissNotification(warningId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary returns warning details for the logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsFetchLatestWarningDetail(options) {
            return localVarFp.warningDetailsFetchLatestWarningDetail(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningDetailsListWarningDetails(options) {
            return localVarFp.warningDetailsListWarningDetails(options).then((request) => request(axios, basePath));
        },
    };
};
exports.WarningDetailsApiFactory = WarningDetailsApiFactory;
/**
 * WarningDetailsApi - object-oriented interface
 * @export
 * @class WarningDetailsApi
 * @extends {BaseAPI}
 */
class WarningDetailsApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateWarningDetailReq} [createWarningDetailReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarningDetailsApi
     */
    warningDetailsCreateNewWarningDetail(createWarningDetailReq, options) {
        return exports.WarningDetailsApiFp(this.configuration).warningDetailsCreateNewWarningDetail(createWarningDetailReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [warningId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarningDetailsApi
     */
    warningDetailsDeleteWarningDetail(warningId, options) {
        return exports.WarningDetailsApiFp(this.configuration).warningDetailsDeleteWarningDetail(warningId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [warningId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarningDetailsApi
     */
    warningDetailsDismissNotification(warningId, options) {
        return exports.WarningDetailsApiFp(this.configuration).warningDetailsDismissNotification(warningId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary returns warning details for the logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarningDetailsApi
     */
    warningDetailsFetchLatestWarningDetail(options) {
        return exports.WarningDetailsApiFp(this.configuration).warningDetailsFetchLatestWarningDetail(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WarningDetailsApi
     */
    warningDetailsListWarningDetails(options) {
        return exports.WarningDetailsApiFp(this.configuration).warningDetailsListWarningDetails(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WarningDetailsApi = WarningDetailsApi;
